import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinkedinComponent } from './simple-icons-linkedin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinkedinComponent ],
    exports:      [ SimpleIconsLinkedinComponent ],
    bootstrap:    []
})
export class SimpleIconsLinkedinModule {}
